import { render, staticRenderFns } from "./MovieCard.vue?vue&type=template&id=52a31662&scoped=true&"
import script from "./MovieCard.vue?vue&type=script&lang=js&"
export * from "./MovieCard.vue?vue&type=script&lang=js&"
import style0 from "./MovieCard.vue?vue&type=style&index=0&id=52a31662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a31662",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/mgrunwald/Projects/Vue.js/playground/movie-app-dev/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VContainer,VFlex,VIcon,VLayout,VSpacer})
